import { entityStore } from '~/utility/BinSentry-ui-utility';
import { LitEntity, html, css, renderIf } from '../utility/lit-entity';
import { sharedStyles } from '../styles/shared-styles';
import { bannerStyles } from '../styles/banner-styles';
import '../common/bn-icon';
import '../common/bn-modal';
import '../common/bn-modal-button';
import './entity-note-save';
import './entity-note';

class EntityNoteList extends LitEntity {
  constructor() {
    super();
    this.notes = [];
  }

  static get properties() {
    return {
      notes: { type: Array, attribute: false },
      readonly: { type: Boolean },
    };
  }

  static get styles() {
    return [sharedStyles, bannerStyles, css`
      .actions {
        display: flex;
        justify-content: end;
        margin-bottom: .5rem;
      }
    `];
  }

  render() {
    if (!this.entity) {
      return html``;
    }

    const response = () => entityStore.invalidateHref(this.href);

    return html`
      ${renderIf(!this.readonly, () => html`
        <div class="actions">
          ${renderIf(this.entity?.hasAction('add-note'), () => html`
            <bn-modal-button button-class="button--outlined" close-on-success>
              <span slot="text">Add Note</span>
              <bn-modal slot="modal">
                <span slot="title">Add Note</span>
                <div class="banner banner--info">
                  Notes are visible to all users who can view this organization.
                </div>
                <entity-note-save .href=${this.href} @response="${response}" clear-on-success actionname="add-note"></entity-note-save>
              </bn-modal>
            </bn-modal-button>
          `)}
        </div>
      `)}
      ${this.notes.map(note => html`
        <entity-note .href="${note.getLink('self').href}" @response="${response}" ?readonly="${this.readonly}"></entity-note>
      `)}
    `;
  }

  _entityChanged(entity) {
    super._entityChanged(entity);
    this.notes = this.entity?.getSubEntitiesByClass('note') || [];
  }
}

customElements.define('entity-note-list', EntityNoteList);
